import styled from 'styled-components';

export const Wrapper = styled.div`
  max-width: 450px;
  margin: 1.5rem auto;

  @media screen and (max-width: 768px) {
    margin: 0.5rem auto;
  }
`;

export const Paragraph = styled.p`
  margin: 1rem auto;
  text-align: center;
`;

export const Links = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 300px;
  margin: 2rem auto;

  @media screen and (max-width: 768px) {
    width: 220px;
    margin: 1rem auto;
  }
`;
